import React, { useState, useCallback } from 'react';
import { t } from '../i18n';
import GamesHub from '../components/GamesHub';

function ShareWin({ message }) {
  const text = encodeURIComponent(`${message} Play on PenFlow!`);
  const url = encodeURIComponent(window.location.origin);
  const btns = [
    { href: `https://wa.me/?text=${text}%20${url}`, bg: '#25D366', label: 'WhatsApp', icon: 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 16.582c-.252.717-1.493 1.408-2.045 1.494-.523.08-1.175.114-1.896-.119-.437-.138-.997-.322-1.713-.631-3.007-1.298-4.973-4.331-5.123-4.532-.149-.198-1.213-1.613-1.213-3.078 0-1.464.769-2.185 1.042-2.484.272-.298.595-.373.794-.373h.573c.184 0 .434-.07.681.519.254.602.863 2.095.937 2.247.075.152.125.328-.025.527-.149.198-.224.322-.372.496-.149.174-.312.389-.178.636.174.298.772 1.273 1.657 2.062 1.138 1.014 2.099 1.328 2.397 1.478.298.149.473.124.647-.075.174-.198.744-.867.942-1.165.198-.298.397-.249.67-.149.272.099 1.735.817 2.033.966.298.149.497.224.572.348.074.124.074.719-.178 1.436z' },
    { href: `https://twitter.com/intent/tweet?text=${text}&url=${url}`, bg: '#000000', label: 'X/Twitter', icon: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.259 5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
    { href: `https://t.me/share/url?url=${url}&text=${text}`, bg: '#0088cc', label: 'Telegram', icon: 'M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L6.196 13.9l-2.948-.924c-.64-.203-.654-.64.135-.954l11.566-4.458c.537-.194 1.006.131.945.657z' },
    { href: `https://www.facebook.com/sharer/sharer.php?u=${url}`, bg: '#1877F2', label: 'Facebook', icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
  ];
  return (
    <div style={{ marginTop: '12px', textAlign: 'center' }}>
      <p style={{ color: '#999', fontSize: '12px', marginBottom: '8px' }}>{t('gm_share_win')}</p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
        {btns.map(b => (
          <a key={b.label} href={b.href} target="_blank" rel="noopener noreferrer" title={b.label}
            style={{ width: 36, height: 36, borderRadius: '50%', background: b.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(0,0,0,0.2)' }}>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="white"><path d={b.icon} /></svg>
          </a>
        ))}
      </div>
    </div>
  );
}

// ── PI TRIVIA ──────────────────────────────────────────────────────────────
const TRIVIA = [
  { q: 'What is Pi Network native currency?', options: ['Pi', 'PiCoin', 'PiToken', 'PiCash'], ans: 0 },
  { q: 'When was Pi Network launched?', options: ['2017', '2018', '2019', '2020'], ans: 2 },
  { q: 'Who founded Pi Network?', options: ['Vitalik Buterin', 'Nicolas Kokkalis', 'Satoshi Nakamoto', 'Elon Musk'], ans: 1 },
  { q: 'What consensus does Pi use?', options: ['Proof of Work', 'Proof of Stake', 'Stellar Consensus', 'DPoS'], ans: 2 },
  { q: 'Pi Browser is used for?', options: ['Web browsing', 'Mining Pi', 'Running dApps', 'Trading'], ans: 2 },
  { q: 'What is PenFlow built on?', options: ['Ethereum', 'Bitcoin', 'Pi Network', 'Solana'], ans: 2 },
  { q: 'KYC stands for?', options: ['Know Your Currency', 'Keep Your Coins', 'Know Your Customer', 'Key Your Code'], ans: 2 },
  { q: 'Pi founders are from?', options: ['MIT', 'Harvard', 'Stanford', 'Oxford'], ans: 2 },
];

function PiTrivia() {
  const [shuffled] = useState(() => [...TRIVIA].sort(() => Math.random() - 0.5).slice(0, 6));
  const [cur, setCur] = useState(0);
  const [score, setScore] = useState(0);
  const [sel, setSel] = useState(null);
  const [done, setDone] = useState(false);

  const answer = (i) => {
    if (sel !== null) return;
    setSel(i);
    if (i === shuffled[cur].ans) setScore(s => s + 1);
    setTimeout(() => {
      if (cur + 1 >= shuffled.length) setDone(true);
      else { setCur(c => c + 1); setSel(null); }
    }, 900);
  };

  if (done) return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '56px' }}>🏆</div>
      <h2 style={{ color: '#0F6E56' }}>Score: {score}/{shuffled.length}</h2>
      <p>{score >= 5 ? '🔥 Pi Expert!' : score >= 3 ? '👍 Good!' : '📚 Keep Learning!'}</p>
      <ShareWin message={`I scored ${score}/${shuffled.length} in Pi Trivia!`} />
      <button style={{ ...S.btn, marginTop: '12px' }} onClick={() => { setCur(0); setScore(0); setSel(null); setDone(false); }}>{t('gm_play_again')}</button>
    </div>
  );

  const q = shuffled[cur];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
      <div style={{ textAlign: 'center', color: '#999', fontSize: '13px' }}>Q {cur + 1}/{shuffled.length} · Score: {score}</div>
      <div style={{ fontWeight: 'bold', fontSize: '16px', textAlign: 'center', color: '#333', lineHeight: 1.5 }}>{q.q}</div>
      {q.options.map((opt, i) => (
        <button key={i} style={{
          padding: '12px', borderRadius: '10px', border: '2px solid #ddd', cursor: 'pointer', fontSize: '14px', textAlign: 'left',
          backgroundColor: sel === null ? 'white' : i === q.ans ? '#10b981' : sel === i ? '#ff4444' : 'white',
          color: sel !== null && (i === q.ans || sel === i) ? 'white' : '#333',
        }} onClick={() => answer(i)}>{opt}</button>
      ))}
    </div>
  );
}

// ── WORD PUZZLE ────────────────────────────────────────────────────────────
const WORDS = [
  { word: 'BLOCKCHAIN', hint: 'Technology behind crypto' },
  { word: 'MINING', hint: 'How Pi is earned daily' },
  { word: 'WALLET', hint: 'Stores your Pi coins' },
  { word: 'PENFLOW', hint: 'This blogging platform' },
  { word: 'PIONEER', hint: 'Pi Network early adopter' },
  { word: 'CONSENSUS', hint: 'Agreement mechanism in Pi' },
];

function WordPuzzle() {
  const [wi, setWi] = useState(0);
  const [guessed, setGuessed] = useState([]);
  const [wrong, setWrong] = useState(0);
  const maxW = 6;
  const { word, hint } = WORDS[wi];
  const won = word.split('').every(l => guessed.includes(l));
  const lost = wrong >= maxW;
  const faces = ['😀','😟','😰','😨','😱','💀'];

  const guess = (l) => {
    if (guessed.includes(l) || won || lost) return;
    const ng = [...guessed, l];
    setGuessed(ng);
    if (!word.includes(l)) setWrong(w => w + 1);
  };

  const next = () => {
    setWi(i => (i + 1) % WORDS.length);
    setGuessed([]); setWrong(0);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
      <div style={{ backgroundColor: '#f3e5f5', padding: '8px 16px', borderRadius: '10px', color: '#0F6E56', fontSize: '14px' }}>Hint: {hint}</div>
      <div style={{ fontSize: '30px' }}>{faces[Math.min(wrong, 5)]} {wrong}/{maxW}</div>
      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', justifyContent: 'center' }}>
        {word.split('').map((l, i) => (
          <div key={i} style={{ width: '32px', height: '40px', border: '2px solid #0F6E56', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontWeight: 'bold', color: '#0F6E56' }}>
            {guessed.includes(l) ? l : ''}
          </div>
        ))}
      </div>
      {(won || lost) ? (
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '20px' }}>{won ? '🎉 You Won!' : `😢 Word was: ${word}`}</p>
          {won && <ShareWin message={`I guessed "${word}" in PenFlow Word Puzzle!`} />}
          <button style={{ ...S.btn, marginTop: '10px' }} onClick={next}>{t('gm_next_word')}</button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', justifyContent: 'center', maxWidth: '310px' }}>
          {'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(l => (
            <button key={l} style={{
              width: '32px', height: '32px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px',
              backgroundColor: guessed.includes(l) ? (word.includes(l) ? '#10b981' : '#ff4444') : '#f3e5f5',
              color: guessed.includes(l) ? 'white' : '#0F6E56',
            }} onClick={() => guess(l)}>{l}</button>
          ))}
        </div>
      )}
    </div>
  );
}

// ── CHESS ──────────────────────────────────────────────────────────────────



// ── TIC TAC TOE ────────────────────────────────────────────────────────────
const TTT_LINES = [[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8],[0,4,8],[2,4,6]];
const checkTTT = (b) => {
  for (let [a,i,j] of TTT_LINES) {
    if (b[a] && b[a] === b[i] && b[a] === b[j]) return { w: b[a], line: [a,i,j] };
  }
  return b.every(Boolean) ? { w: 'Draw', line: [] } : null;
};
const minimax = (b, isMax) => {
  const r = checkTTT(b);
  if (r) return r.w === 'O' ? 10 : r.w === 'X' ? -10 : 0;
  let best = isMax ? -Infinity : Infinity;
  b.forEach((c, i) => {
    if (!c) {
      b[i] = isMax ? 'O' : 'X';
      const v = minimax(b, !isMax);
      b[i] = null;
      best = isMax ? Math.max(best, v) : Math.min(best, v);
    }
  });
  return best;
};
const bestMove = (b) => {
  let bv = -Infinity, bm = -1;
  b.forEach((c, i) => { if (!c) { b[i] = 'O'; const v = minimax(b, false); b[i] = null; if (v > bv) { bv = v; bm = i; } } });
  return bm;
};

function TicTacToe() {
  const [mode, setMode] = useState(null);
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isX, setIsX] = useState(true);
  const [result, setResult] = useState(null);
  const [streak, setStreak] = useState({ X: 0, O: 0, D: 0 });
  const cs = Math.floor((Math.min(typeof window !== 'undefined' ? window.innerWidth : 380, 380) - 60) / 3);

  const doMove = useCallback((b, idx, sym) => {
    const nb = [...b]; nb[idx] = sym;
    const r = checkTTT(nb);
    setBoard(nb);
    if (r) { setResult(r); setStreak(s => ({ ...s, [r.w === 'Draw' ? 'D' : r.w]: s[r.w === 'Draw' ? 'D' : r.w] + 1 })); return nb; }
    return nb;
  }, []);

  const click = (i) => {
    if (board[i] || result) return;
    if (mode === 'ai' && !isX) return;
    const nb = doMove(board, i, isX ? 'X' : 'O');
    if (!checkTTT(nb)) {
      setIsX(x => !x);
      if (mode === 'ai') {
        setTimeout(() => {
          const m = bestMove([...nb]);
          if (m !== -1) { const nb2 = doMove(nb, m, 'O'); if (!checkTTT(nb2)) setIsX(true); }
        }, 350);
      }
    }
  };

  const reset = () => { setBoard(Array(9).fill(null)); setIsX(true); setResult(null); };

  if (!mode) return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '48px', marginBottom: '8px' }}>❌⭕</div>
      <h3 style={{ color: '#0F6E56' }}>{t('gm_choose_mode')}</h3>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
        <button style={{ ...S.btn, background: '#10b981' }} onClick={() => setMode('pvp')}>{t('gm_2players')}</button>
        <button style={{ ...S.btn, background: '#0d9488' }} onClick={() => setMode('ai')}>{t('gm_vs_ai')}</button>
      </div>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
      <div style={{ display: 'flex', gap: '16px', background: '#f3e5f5', padding: '6px 16px', borderRadius: '20px' }}>
        <span style={{ color: '#0F6E56', fontWeight: 'bold' }}>X:{streak.X}</span>
        <span style={{ color: '#999' }}>D:{streak.D}</span>
        <span style={{ color: '#0d9488', fontWeight: 'bold' }}>O:{streak.O}</span>
      </div>
      <div style={{ fontWeight: 'bold', color: '#0F6E56' }}>
        {result ? (result.w === 'Draw' ? "Draw!" : `${mode === 'ai' && result.w === 'O' ? 'AI' : result.w} Wins! 🎉`) : `${mode === 'ai' && !isX ? 'AI...' : `Player ${isX ? 'X' : 'O'}`}`}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '8px' }}>
        {board.map((c, i) => {
          const win = result && result.line && result.line.includes(i);
          return (
            <div key={i} onClick={() => click(i)} style={{
              width: cs, height: cs, borderRadius: '12px', border: `3px solid ${win ? '#34d399' : '#0F6E56'}`,
              background: win ? '#34d399' : c === 'X' ? '#f3e5f5' : c === 'O' ? '#fff3e0' : '#fafafa',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: cs * 0.48, fontWeight: 'bold', cursor: 'pointer',
              color: c === 'X' ? '#0F6E56' : '#0d9488',
            }}>{c}</div>
          );
        })}
      </div>
      {result && <>
        {result.w !== 'Draw' && <ShareWin message={`${mode === 'ai' && result.w === 'O' ? 'AI' : `Player ${result.w}`} won TicTacToe on PenFlow!`} />}
        <button style={S.btn} onClick={reset}>{t('gm_play_again')}</button>
      </>}
      {!result && <button style={{ ...S.btn, background: '#999' }} onClick={reset}>{t('gm_reset')}</button>}
      <button style={{ fontSize: '12px', color: '#999', background: 'none', border: 'none', cursor: 'pointer' }} onClick={() => { setMode(null); reset(); }}>{t('gm_change_mode')}</button>
    </div>
  );
}

// ── UNO ────────────────────────────────────────────────────────────────────
const COLORS = ['red','green','blue','yellow'];
const VALS = ['0','1','2','3','4','5','6','7','8','9','Skip','Rev','+2'];
const CLR_MAP = { red:'#ef4444', green:'#22c55e', blue:'#3b82f6', yellow:'#0d9488', black:'#1a1a1a' };

const makeUNODeck = () => {
  const deck = [];
  COLORS.forEach(col => VALS.forEach(v => { deck.push({ col, val: v }); deck.push({ col, val: v }); }));
  ['Wild','Wild+4','Wild','Wild+4'].forEach(v => deck.push({ col: 'black', val: v }));
  return deck.sort(() => Math.random() - 0.5);
};

function UnoCard({ card, onClick, small }) {
  if (!card) return null;
  const size = small ? 38 : 56;
  return (
    <div onClick={onClick} style={{
      width: size, height: size * 1.55, borderRadius: 8,
      background: `linear-gradient(135deg, ${CLR_MAP[card.col] || '#999'}, ${CLR_MAP[card.col] || '#999'}cc)`,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      color: 'white', fontWeight: 'bold', fontSize: small ? 11 : 15,
      border: '2px solid rgba(255,255,255,0.6)', cursor: onClick ? 'pointer' : 'default',
      flexShrink: 0, textAlign: 'center', lineHeight: 1.1, padding: 2,
      boxShadow: onClick ? '0 4px 12px rgba(0,0,0,0.3)' : '0 2px 6px rgba(0,0,0,0.2)',
      transform: onClick ? 'translateY(0px)' : 'none',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', width: '70%', height: '70%', borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)' }} />
      <span style={{ position: 'relative', zIndex: 1, textShadow: '0 1px 3px rgba(0,0,0,0.4)' }}>{card.val}</span>
    </div>
  );
}

function Uno() {
  const [deck, setDeck] = useState([]);
  const [playerHand, setPlayerHand] = useState([]);
  const [aiHand, setAiHand] = useState([]);
  const [pile, setPile] = useState([]);
  const [turn, setTurn] = useState('player');
  const [msg, setMsg] = useState('');
  const [started, setStarted] = useState(false);
  const [wildColor, setWildColor] = useState(null);
  const [choosingColor, setChoosingColor] = useState(false);
  const [pendingWild, setPendingWild] = useState(null);

  const start = () => {
    const d = makeUNODeck();
    const ph = d.splice(0, 7);
    const ah = d.splice(0, 7);
    let top = d.splice(0, 1)[0];
    while (top.col === 'black') { d.push(top); top = d.splice(0, 1)[0]; }
    setDeck(d); setPlayerHand(ph); setAiHand(ah); setPile([top]);
    setTurn('player'); setMsg(''); setStarted(true); setWildColor(null);
  };

  const topCard = pile[pile.length - 1];
  const effectiveColor = wildColor || topCard?.col;

  const canPlay = (card) => {
    if (!topCard) return true;
    if (card.col === 'black') return true;
    if (card.col === effectiveColor) return true;
    if (card.val === topCard.val) return true;
    return false;
  };

  const playCard = (card, fromHand, setHand) => {
    if (card.col === 'black') {
      setPendingWild({ card, fromHand, setHand });
      setChoosingColor(true);
      return;
    }
    const nh = [...fromHand]; 
    const idx = nh.findIndex(c => c === card);
    nh.splice(idx, 1);
    setHand(nh);
    setPile(p => [...p, card]);
    setWildColor(null);
    if (nh.length === 0) { setMsg(turn === 'player' ? t('gm_you_win') : t('gm_ai_wins')); return; }
    // Special cards
    if (card.val === '+2') {
      if (turn === 'player') { setAiHand(h => [...h, ...(deck.splice(0,2))]); setDeck([...deck]); }
      else { setPlayerHand(h => [...h, ...(deck.splice(0,2))]); setDeck([...deck]); }
    }
    setTurn(t => t === 'player' ? 'ai' : 'player');
    if (turn === 'player') setTimeout(aiTurn, 800);
  };

  const chooseColor = (col) => {
    if (!pendingWild) return;
    const { card, fromHand, setHand } = pendingWild;
    const nh = [...fromHand];
    const idx = nh.findIndex(c => c === card);
    nh.splice(idx, 1);
    setHand(nh);
    setPile(p => [...p, card]);
    setWildColor(col);
    setChoosingColor(false);
    setPendingWild(null);
    if (nh.length === 0) { setMsg(t('gm_you_win')); return; }
    if (card.val === 'Wild+4') { setAiHand(h => [...h, ...(deck.splice(0,4))]); setDeck([...deck]); }
    setTurn('ai');
    setTimeout(aiTurn, 900);
  };

  const aiTurn = () => {
    setAiHand(ah => {
      setPile(p => {
        const top = p[p.length - 1];
        const ec = wildColor || top?.col;
        const playable = ah.filter(c => c.col === 'black' || c.col === ec || c.val === top?.val);
        if (playable.length > 0) {
          const card = playable[0];
          const nh = [...ah]; nh.splice(ah.indexOf(card), 1);
          const newPile = [...p, card];
          if (nh.length === 0) { setMsg(t('gm_ai_wins')); setAiHand(nh); return newPile; }
          let wc = null;
          if (card.col === 'black') wc = COLORS[Math.floor(Math.random() * 4)];
          setWildColor(wc);
          setAiHand(nh);
          setTurn('player');
          return newPile;
        } else {
          setDeck(d => {
            const nd = [...d];
            const drawn = nd.splice(0, 1);
            setAiHand([...ah, ...drawn]);
            return nd;
          });
          setTurn('player');
          return p;
        }
      });
      return ah;
    });
  };

  const drawCard = () => {
    if (turn !== 'player' || !started) return;
    if (deck.length === 0) { setMsg(t('gm_deck_empty')); return; }
    const nd = [...deck]; const drawn = nd.splice(0, 1);
    setDeck(nd); setPlayerHand(h => [...h, ...drawn]);
    setTurn('ai'); setTimeout(aiTurn, 800);
  };

  if (!started) return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '48px', marginBottom: '8px' }}>🃏</div>
      <h3 style={{ color: '#0F6E56' }}>{t('gm_uno_title')}</h3>
      <p style={{ color: '#999', fontSize: '13px' }}>{t('gm_uno_help')}</p>
      <button style={S.btn} onClick={start}>{t('gm_deal')}</button>
    </div>
  );

  if (msg) return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '48px' }}>{msg.includes('You') ? '🎉' : '🤖'}</div>
      <h3 style={{ color: '#0F6E56' }}>{msg}</h3>
      {msg.includes('You') && <ShareWin message="I beat AI in UNO on PenFlow!" />}
      <button style={{ ...S.btn, marginTop: '12px' }} onClick={start}>{t('gm_play_again')}</button>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {choosingColor && (
        <div style={{ textAlign: 'center', background: '#f3e5f5', padding: '12px', borderRadius: '12px' }}>
          <p style={{ fontWeight: 'bold', color: '#0F6E56', marginBottom: '8px' }}>{t('gm_wild_color')}</p>
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
            {COLORS.map(col => (
              <div key={col} onClick={() => chooseColor(col)} style={{ width: 36, height: 36, borderRadius: '50%', background: CLR_MAP[col], cursor: 'pointer', border: '3px solid white', boxShadow: '0 2px 6px rgba(0,0,0,0.3)' }} />
            ))}
          </div>
        </div>
      )}
      <div style={{ background: '#f9f9f9', padding: '8px', borderRadius: '10px', textAlign: 'center' }}>
        <div style={{ fontSize: '12px', color: '#999', marginBottom: '6px' }}>AI Hand: {aiHand.length} cards</div>
        <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
          {aiHand.map((_, i) => <div key={i} style={{ width: 28, height: 42, background: '#0F6E56', borderRadius: 4, border: '1px solid #4a00c0' }} />)}
        </div>
      </div>
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', justifyContent: 'center' }}>
        <div>
          <div style={{ fontSize: '11px', color: '#999', textAlign: 'center', marginBottom: '4px' }}>{t('gm_top_card')}</div>
          <UnoCard card={{ ...topCard, col: wildColor || topCard?.col }} />
        </div>
        <div>
          <div style={{ fontSize: '11px', color: '#999', textAlign: 'center', marginBottom: '4px' }}>{t('gm_draw')}</div>
          <div onClick={drawCard} style={{ width: 52, height: 78, borderRadius: 6, background: turn === 'player' ? '#0F6E56' : '#ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: '11px', cursor: turn === 'player' ? 'pointer' : 'default', border: '2px solid rgba(255,255,255,0.3)' }}>
            {deck.length}<br/>left
          </div>
        </div>
      </div>
      <div style={{ background: '#f0f0f0', padding: '6px', borderRadius: '8px', textAlign: 'center', fontWeight: 'bold', color: turn === 'player' ? '#10b981' : '#0d9488', fontSize: '13px' }}>
        {turn === 'player' ? t('gm_your_turn') : t('gm_ai_thinking')}
      </div>
      <div>
        <div style={{ fontSize: '12px', color: '#999', marginBottom: '6px' }}>Your Hand ({playerHand.length} cards):</div>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {playerHand.map((card, i) => (
            <div key={i} style={{ opacity: turn === 'player' && canPlay(card) ? 1 : 0.5, transform: turn === 'player' && canPlay(card) ? 'translateY(-4px)' : 'none', transition: 'all 0.2s' }}>
              <UnoCard card={card} onClick={turn === 'player' && canPlay(card) ? () => playCard(card, playerHand, setPlayerHand) : null} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── LUDO ───────────────────────────────────────────────────────────────────
const LUDO_COLORS = ['red', 'green', 'blue', 'yellow'];
const LUDO_CLR = { red: '#ef4444', green: '#22c55e', blue: '#3b82f6', yellow: '#0d9488' };
const LUDO_LIGHT = { red: '#fecaca', green: '#bbf7d0', blue: '#bfdbfe', yellow: '#fef08a' };
const SAFE_SQUARES = [1, 9, 14, 22, 27, 35, 40, 48];

// Path for each color (52 squares main track)
const START_SQ = { red: 1, green: 14, blue: 27, yellow: 40 };
const HOME_ENTRY = { red: 51, green: 12, blue: 25, yellow: 38 };

function LudoBoard({ pieces, curPlayer, onCellClick, dice, rolled }) {
  const size = Math.min(typeof window !== 'undefined' ? window.innerWidth - 20 : 360, 380);
  const cell = size / 15;

  // Board layout: 15x15 grid
  // Red home: top-left (0-5, 0-5)
  // Green home: top-right (0-5, 9-14)  
  // Blue home: bottom-right (9-14, 9-14)
  // Yellow home: bottom-left (9-14, 0-5)
  // Center: 6-8, 6-8

  const getColor = (r, c) => {
    if (r <= 5 && c <= 5) return LUDO_LIGHT.red;
    if (r <= 5 && c >= 9) return LUDO_LIGHT.green;
    if (r >= 9 && c >= 9) return LUDO_LIGHT.blue;
    if (r >= 9 && c <= 5) return LUDO_LIGHT.yellow;
    // Colored tracks
    if (c === 7 && r >= 1 && r <= 5) return LUDO_LIGHT.red;
    if (r === 7 && c >= 9 && c <= 13) return LUDO_LIGHT.green;
    if (c === 7 && r >= 9 && r <= 13) return LUDO_LIGHT.blue;
    if (r === 7 && c >= 1 && c <= 5) return LUDO_LIGHT.yellow;
    if (r >= 6 && r <= 8 && c >= 6 && c <= 8) return '#fff';
    return '#fff';
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(15, ${cell}px)`, border: '3px solid #333', borderRadius: '8px', overflow: 'hidden', width: size, height: size }}>
      {Array.from({ length: 15 }, (_, r) =>
        Array.from({ length: 15 }, (_, c) => {
          const bg = getColor(r, c);
          const isCenter = r >= 6 && r <= 8 && c >= 6 && c <= 8;
          const isSafe = false;
          return (
            <div key={`${r}-${c}`} style={{
              width: cell, height: cell, backgroundColor: bg,
              border: '0.5px solid #ddd', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: cell * 0.5, cursor: 'pointer', boxSizing: 'border-box',
              background: isCenter ? 'linear-gradient(135deg, #ef4444 25%, #22c55e 25%, #22c55e 50%, #3b82f6 50%, #3b82f6 75%, #0d9488 75%)' : bg,
            }}>
            </div>
          );
        })
      )}
    </div>
  );
}

function Ludo() {
  const [pieces, setPieces] = useState({
    red: [-1, -1, -1, -1],
    green: [-1, -1, -1, -1],
    blue: [-1, -1, -1, -1],
    yellow: [-1, -1, -1, -1]
  });
  const [curPlayer, setCurPlayer] = useState(0);
  const [dice, setDice] = useState(null);
  const [rolled, setRolled] = useState(false);
  const [msg, setMsg] = useState('');
  const [started, setStarted] = useState(false);
  const [players, setPlayers] = useState(2);

  const diceEmoji = ['', '⚀', '⚁', '⚂', '⚃', '⚄', '⚅'];
  const cur = LUDO_COLORS[curPlayer];

  const rollDice = () => {
    if (rolled || msg) return;
    const d = Math.floor(Math.random() * 6) + 1;
    setDice(d);
    setRolled(true);
  };

  const movePiece = (colorIdx, pieceIdx) => {
    if (!rolled || msg) return;
    const color = LUDO_COLORS[colorIdx];
    if (color !== cur) return;

    const pos = pieces[color][pieceIdx];
    if (pos === -1 && dice !== 6) return;

    const newPieces = { ...pieces, [color]: [...pieces[color]] };

    if (pos === -1 && dice === 6) {
      newPieces[color][pieceIdx] = START_SQ[color];
    } else if (pos !== -1) {
      let newPos = pos + dice;
      if (newPos > 57) newPos = 57 - (newPos - 57);
      newPieces[color][pieceIdx] = newPos;
      if (newPos >= 57) {
        newPieces[color][pieceIdx] = 57;
        if (newPieces[color].every(p => p === 57)) {
          setMsg(`${color.toUpperCase()} WINS! 🎉`);
          setPieces(newPieces);
          setRolled(false);
          return;
        }
      }
    }

    setPieces(newPieces);
    setRolled(false);
    if (dice !== 6) setCurPlayer(p => (p + 1) % players);
  };

  if (!started) return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '48px', marginBottom: '8px' }}>🎲</div>
      <h3 style={{ color: '#0F6E56', marginBottom: '16px' }}>{t('gm_ludo')}</h3>
      <p style={{ color: '#999', fontSize: '13px', marginBottom: '16px' }}>{t('gm_how_many')}</p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '16px' }}>
        {[2, 3, 4].map(n => (
          <button key={n} style={{ ...S.btn, backgroundColor: players === n ? '#0F6E56' : '#f3e5f5', color: players === n ? 'white' : '#0F6E56' }}
            onClick={() => setPlayers(n)}>{n} Players</button>
        ))}
      </div>
      <button style={S.btn} onClick={() => setStarted(true)}>{t('gm_start_game')}</button>
    </div>
  );

  if (msg) return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '48px' }}>🏆</div>
      <h3 style={{ color: '#0F6E56', fontSize: '20px' }}>{msg}</h3>
      <ShareWin message={`${msg} I won Ludo on PenFlow!`} />
      <button style={{ ...S.btn, marginTop: '12px' }} onClick={() => {
        setPieces({ red:[-1,-1,-1,-1], green:[-1,-1,-1,-1], blue:[-1,-1,-1,-1], yellow:[-1,-1,-1,-1] });
        setCurPlayer(0); setDice(null); setRolled(false); setMsg(''); setStarted(false);
      }}>{t('gm_play_again')}</button>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
      {/* Turn indicator */}
      <div style={{ backgroundColor: LUDO_CLR[cur], color: 'white', padding: '8px 20px', borderRadius: '20px', fontWeight: 'bold', fontSize: '14px' }}>
        {cur.toUpperCase()}'s Turn {dice ? `· Rolled: ${diceEmoji[dice]}` : ''}
      </div>

      {/* Board */}
      <LudoBoard pieces={pieces} curPlayer={curPlayer} dice={dice} rolled={rolled} />

      {/* Dice */}
      <div onClick={rollDice} style={{
        width: 64, height: 64, backgroundColor: rolled ? '#ccc' : LUDO_CLR[cur],
        borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '36px', cursor: rolled ? 'default' : 'pointer', color: 'white',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)', userSelect: 'none',
      }}>
        {dice ? diceEmoji[dice] : '🎲'}
      </div>

      {/* Pieces */}
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
        {LUDO_COLORS.slice(0, players).map((color, ci) => (
          <div key={color} style={{ backgroundColor: LUDO_LIGHT[color], borderRadius: '12px', padding: '10px', border: `2px solid ${LUDO_CLR[color]}` }}>
            <div style={{ fontWeight: 'bold', color: LUDO_CLR[color], fontSize: '12px', marginBottom: '6px', textAlign: 'center' }}>
              {color.toUpperCase()} {color === cur ? '▶' : ''}
            </div>
            <div style={{ display: 'flex', gap: '6px' }}>
              {pieces[color].map((pos, pi) => (
                <div key={pi} onClick={() => movePiece(ci, pi)} style={{
                  width: 36, height: 36, borderRadius: '50%',
                  backgroundColor: LUDO_CLR[color],
                  border: color === cur && rolled && (pos !== -1 || dice === 6) ? '3px solid #34d399' : '2px solid rgba(255,255,255,0.5)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'white', fontWeight: 'bold', fontSize: '11px',
                  cursor: color === cur && rolled ? 'pointer' : 'default',
                  opacity: pos === -1 ? 0.5 : 1,
                  boxShadow: color === cur && rolled && (pos !== -1 || dice === 6) ? '0 0 8px #34d399' : 'none',
                }}>
                  {pos === -1 ? '🏠' : pos >= 57 ? '★' : pos}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: '11px', color: '#999' }}>{t('gm_ludo_help')}</div>
    </div>
  );
}

// ── MAIN ───────────────────────────────────────────────────────────────────
const GAMES = [
  { id: 'trivia', label: 'Pi Trivia' },
  { id: 'word', label: 'Word Puzzle' },
  { id: 'ttt', label: 'TicTacToe' },
  { id: 'uno', label: 'UNO' },
  { id: 'online', label: '🌐 Online' },
  { id: 'more', label: '🎮 More Games' },
];

export default function Games() {
  const [active, setActive] = useState('trivia');
  return (
    <div style={{ maxWidth: '580px', margin: '20px auto', padding: '12px' }}>
      <h1 style={{ textAlign: 'center', color: '#0F6E56', marginBottom: '4px' }}>{t('gm_title')}</h1>
      <p style={{ textAlign: 'center', color: '#999', fontSize: '13px', marginBottom: '16px' }}>{t('gm_tagline')}</p>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '16px', justifyContent: 'center' }}>
        {GAMES.map(g => (
          <button key={g.id} style={{
            padding: '7px 14px', borderRadius: '20px', border: '2px solid #0F6E56', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer',
            background: active === g.id ? '#0F6E56' : 'white', color: active === g.id ? 'white' : '#0F6E56',
          }} onClick={() => setActive(g.id)}>{g.label}</button>
        ))}
      </div>
      <div style={{ background: 'white', borderRadius: '16px', padding: '18px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        {active === 'trivia' && <PiTrivia />}
        {active === 'word' && <WordPuzzle />}
        {active === 'ttt' && <TicTacToe />}
        {active === 'uno' && <Uno />}
        {active === 'online' && <div style={{ textAlign: 'center' }}><a href="/online-game" style={{ backgroundColor: '#0F6E56', color: 'white', padding: '12px 24px', borderRadius: '20px', textDecoration: 'none', fontWeight: 'bold', fontSize: '15px' }}>{t('gm_online_ttt')}</a></div>}
        {active === 'more' && <GamesHub />}
      </div>
    </div>
  );
}

const S = {
  btn: { background: '#0F6E56', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '15px' },
  shareBtn: (c) => ({ background: c, color: 'white', padding: '7px 13px', borderRadius: '14px', textDecoration: 'none', fontSize: '12px', fontWeight: 'bold' }),
};
